import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ allShops }: RootState) => allShops;

export const selectAllShop = createSelector(
    selectRoot,
    ({ allShopsList }) => allShopsList,
);
